import { ListCard, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const SidePanelCard = styled(ListCard)<{ $cardPosition: number; $listLength: number }>`
	border-top-left-radius: ${({ $cardPosition }) => ($cardPosition === 0 ? 'auto' : '0px')};
	border-top-right-radius: ${({ $cardPosition }) => ($cardPosition === 0 ? 'auto' : '0px')};
	border-bottom-left-radius: ${({ $cardPosition, $listLength }) => ($cardPosition === $listLength ? 'auto' : '0px')};
	border-bottom-right-radius: ${({ $cardPosition, $listLength }) => ($cardPosition === $listLength ? 'auto' : '0px')};
`;

export const SidePanelCardContent = styled(ListCard.Content)`
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const SidePanelCardEnd = styled(ListCard.End)`
	margin-left: auto;
`;

export const SidePanelCardDefaultCurrency = styled.span`
	${({ theme }) => theme.fonts.text.caption2}
`;

export const SidePanelCardAltCurrency = styled.span`
	${({ theme }) => theme.fonts.text.caption1}
`;

export const ListCardForFTO = styled(ListCard)<{ $disabled?: boolean; $fullWidth?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: ${({ theme }) => theme.spacings.xsmall};
	${({ $fullWidth }) => $fullWidth && `width: 100%;`}
	${({ $disabled }) => $disabled && `pointer-events: none;`}
`;

export const AvailableIn = styled(Text)`
	margin-right: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const AvailableNow = styled(Text)`
	text-transform: uppercase;
`;

export const FtoStarting = styled(Text)`
	text-transform: uppercase;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
`;

export const BaseCurrency = styled(ListCard.SubTitle)`
	${({ theme }) => theme.fonts.text.text5}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Amount = styled(ListCard.SubTitle)`
	${({ theme }) => theme.fonts.text.text4}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;
export const Subtitle = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${({ theme }) => theme.spacings.xxxsmall};
	align-items: baseline;
	color: ${({ theme }) => theme.colors.text.main.subtle};
`;

// atoms use a align-items: center, so we need to override it
export const StartContainer = styled(ListCard.Start)`
	align-items: flex-start;
	padding-top: ${({ theme }) => theme.spacings.small};
`;

export const BuyWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	width: 100%;
`;

export const BuyContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: ${({ theme }) => theme.spacings.xsmall};
	padding-top: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const CardBody = styled(ListCard.Content)`
	margin-right: ${({ theme }) => theme.spacings.small};
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const CardFooter = styled(ListCard.Content)`
	border-top: 1px solid ${({ theme }) => theme.colors.backgrounds.main.subtle};
	width: 96%;
	left: 2%;
	position: relative;
`;

export const FooterText = styled(Text)`
	${({ theme }) => theme.fonts.text.caption2}
`;

export const Bold = styled.span`
	${({ theme }) => theme.fonts.text.caption1}
`;

export const Comment = styled.span`
	display: flex;
	flex-direction: row;
	align-items: center;
	color: ${({ theme }) => theme.colors.text.main.enabled};
	${({ theme }) => theme.fonts.text.caption1}
`;

export const ClaimComment = styled.span`
	color: ${({ theme }) => theme.colors.text.main.enabled};
	${({ theme }) => theme.fonts.text.caption1}
`;

export const TimerContainer = styled(ListCard.End)`
	margin-left: 0;
`;

export const TimerTitle = styled(Comment)`
	margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const BuyButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-left: ${({ theme }) => theme.spacings.xsmall};
	padding-right: ${({ theme }) => theme.spacings.xsmall};
`;

export const BuyAndCap = styled.div``;
